(() => {
  const bar = document.querySelector('[data-dalji-black-site-bar]');
  if (!bar) return;

  const now = Date.now();
  const start = new Date(bar.dataset.start).getTime();
  const end = new Date(bar.dataset.end).getTime();
  const blackDayStart = new Date(bar.dataset.blackDayStart).getTime();
  const blackDayEnd = new Date(bar.dataset.blackDayEnd).getTime();
  const params = new URLSearchParams(window.location.search);
  const forcedPreview = params.get('dalji_black_preview') === '1';
  const designMode = Boolean(window.Shopify && window.Shopify.designMode);
  const isCampaignPage = document.body.classList.contains('black');
  const isLive = now >= start && now <= end;

  if (!(isLive || forcedPreview || designMode || isCampaignPage)) return;

  document.body.classList.add('dalji-black-live');
  bar.hidden = false;

  const message = bar.querySelector('[data-dalji-black-site-message]');
  if (message && now >= blackDayStart && now <= blackDayEnd) {
    message.textContent = message.dataset.blackDay;
  }
})();
